'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.controller("ticketDemandeReouverturePopinController", function ($scope, $http, $q, lovService, $notifications) {
  var ticket = $scope.ticket;
  $scope.params = {
    ticketId: $scope.ticket.id,
    demande: null
  };
  $scope.reouvrir = function () {
    if ($scope.loading) return;
    $scope.loading = true;
    $http.post('/rest/echange/ticket-client/demande-reouverture/' + $scope.params.ticketId, null, {
      params: $scope.params
    }).then(function () {
      $notifications.info("Demande envoyée");
      $scope.$close();
    }).finally(function () {
      $scope.loading = false;
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ticket/demandeReouverture/ticketDemandeReouverturePopinController.js
// module id = 2889
// module chunks = 13